function applyRules(product) {
  const { sales, stock, price } = product;

  // RULE 1
  if (sales < 5 && stock > 50) {
    return {
      status: "CRITICAL",
      reasonKey: "rule_reason_low_sales_high_stock",
      actionKey: "rule_action_reduce_price",
      confidence: 0.85,
    };
  }

  // RULE 2
  if (stock < 10 && sales > 20) {
    return {
      status: "CRITICAL",
      reasonKey: "rule_reason_high_demand_low_stock",
      actionKey: "rule_action_refill_inventory",
      confidence: 0.9,
    };
  }

  // RULE 3
  if (sales > 30 && price === "high") {
    return {
      status: "OPPORTUNITY",
      reasonKey: "rule_reason_strong_sales_high_price",
      actionKey: "rule_action_maintain_price",
      confidence: 0.8,
    };
  }

  // RULE 4
  if (sales >= 10 && sales <= 30 && stock >= 20 && stock <= 100) {
    return {
      status: "STABLE",
      reasonKey: "rule_reason_balanced",
      actionKey: "rule_action_no_action",
      confidence: 0.7,
    };
  }

  // FALLBACK
  return {
    status: "STABLE",
    reasonKey: "rule_reason_no_match",
    actionKey: "rule_action_no_action",
    confidence: 0.6,
  };
}

export default applyRules;